import React, { useEffect, useRef } from 'react'
import { ErrorBoundary as DatadogErrorBoundary } from '@datadog/browser-rum-react'
import { useLocation, useNavigate } from 'react-router-dom'

const ErrorFallback = ({ error, resetError }) => {
  const navigate = useNavigate()
  return (
    <div style={{ margin: 40, color: '#b00', fontSize: 18 }}>
      <h2>Oops, something went wrong!</h2>
      <p>{String(error)}</p>
      <button onClick={resetError} style={{ marginRight: 8 }}>
        Retry
      </button>
      <button onClick={() => navigate('/')}>Go Home</button>
    </div>
  )
}

export type ErrorBoundaryProps = { children: React.ReactNode }

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const location = useLocation()
  const errorBoundaryRef = useRef<any>(null)
  const prevPath = useRef(location.pathname)

  useEffect(() => {
    if (errorBoundaryRef.current && prevPath.current !== location.pathname) {
      errorBoundaryRef.current.resetError()
      prevPath.current = location.pathname
    }
  }, [location.pathname])

  return (
    <DatadogErrorBoundary ref={errorBoundaryRef} fallback={ErrorFallback}>
      {children}
    </DatadogErrorBoundary>
  )
}
